const context = require.context('.', true, /\.js$/)
context.keys().forEach(key => context(key))
